var map = {
	"../pages/addblock/addblock.module": [
		1266,
		20
	],
	"../pages/addimage/addimage.module": [
		1267,
		19
	],
	"../pages/block/block.module": [
		1268,
		3
	],
	"../pages/blockchain/blockchain.module": [
		1269,
		2
	],
	"../pages/changepic/changepic.module": [
		1270,
		18
	],
	"../pages/copyright/copyright.module": [
		1271,
		17
	],
	"../pages/getverified/getverified.module": [
		1272,
		16
	],
	"../pages/googlesignup/googlesignup.module": [
		1273,
		15
	],
	"../pages/login/login.module": [
		1274,
		14
	],
	"../pages/profilepic/profilepic.module": [
		1275,
		13
	],
	"../pages/scanblock/scanblock.module": [
		1276,
		12
	],
	"../pages/signup/signup.module": [
		1277,
		11
	],
	"../pages/stripepay/stripepay.module": [
		1278,
		10
	],
	"../pages/tabs/tabs.module": [
		1279,
		9
	],
	"../pages/takeimage/takeimage.module": [
		1280,
		8
	],
	"../pages/takepic/takepic.module": [
		1281,
		7
	],
	"../pages/uploadpic/uploadpic.module": [
		1282,
		6
	],
	"../pages/verification/verification.module": [
		1283,
		5
	],
	"../pages/viewadded/viewadded.module": [
		1284,
		1
	],
	"../pages/viewmap/viewmap.module": [
		1285,
		4
	],
	"../pages/viewscanned/viewscanned.module": [
		1286,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 355;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 355
// module chunks = 21